import React, { useContext } from "react";
import "../AccountModals/PreApprovedListModal.css";
import { AppContext } from "../../../../AppContext";
import closeSvg from "../../../../assets/closeSvg";
import { logActivity } from "../../../utils";

const UCCListModal = () => {
  const {
    uCCListModalVisible,
    setUCCListModalVisible,
    matrixData,
    makeKey,
    userType,
    userEmail,
    userCompany
  } = useContext(AppContext);

  const dataAvailable = () => {
    if (matrixData[0].Request === "No Request") {
      return false;
    } else {
      return true;
    }
  };

  let clientDataSorted = [];
  let allClients = [];

  if (dataAvailable()) {
    const clientData = JSON.parse(matrixData[0]["Clients"]);
    clientDataSorted = clientData.sort((a, b) => {
      if (a["Name"][0] > b["Name"][0]) {
        return 1;
      } else {
        return -1;
      }
    });

    //Create arrays of all clients

    allClients = clientDataSorted.filter((e) => {
      return (
        e.MtgPlanner_CRM__Stage__c === "New Lead" ||
        e.MtgPlanner_CRM__Stage__c === "Attempting Contact" ||
        e.MtgPlanner_CRM__Stage__c === "Appointment Scheduled" ||
        e.MtgPlanner_CRM__Stage__c === "Application Sent" ||
        e.MtgPlanner_CRM__Stage__c === "Docs Requested" ||
        e.MtgPlanner_CRM__Stage__c === "Docs Received" ||
        e.MtgPlanner_CRM__Stage__c === "Pre-Approved"
      );
    });
  }

  let allClientsList = [];
  let listOfClients;

  if (dataAvailable()) {
    if (allClients[0] == undefined) {
      listOfClients = (
        <div className="ClientRow grey">
          <div className="subtext">
            No current clients. Please let your loan officer know if you have
            any!
          </div>
        </div>
      );
    } else {
      allClientsList = allClients.map((e, index) => {
        const clientName = e.Name;
        const loanOfficerName = e.Loan_Officer_Name__c;
        const loanOfficerEmail = e.Loan_Officer_Email__c;
        const loanOfficerPhone = e.Loan_Officer_Phone__c;
        const agentPartner = e.Agent_Contact_Name__c;
        const agentEmail = e.Agent_Contact_Email__c;

        return {
          clientName,
          loanOfficerName,
          loanOfficerEmail,
          loanOfficerPhone,
          agentPartner,
          agentEmail,
        };
      });
      listOfClients = allClientsList.map((e, index) => {
        function replaceSpacesWithPlus(inputString) {
          if (inputString) {
            const regex = /\s/g;
            const outputString = inputString.replace(regex, "+");
            return outputString;
          } else {
            return null;
          }
        }

        return (
          <a
            href={`https://docs.google.com/forms/d/e/1FAIpQLSdn43DA0Mq1GJOH1-E-Mxn7smRdEfNseSIGHUV1v1g_JXq4uQ/viewform?usp=pp_url&entry.269118355=${replaceSpacesWithPlus(
              e.agentPartner
            )}&entry.938618787=Buying+Agent&entry.1913981406=${replaceSpacesWithPlus(
              e.clientName
            )}&entry.75578781=Loan&entry.210362954=Move+Mortgage&entry.295371917=${replaceSpacesWithPlus(
              e.loanOfficerName
            )}&entry.236660604=${
              e.loanOfficerEmail
            }&entry.1067147851=${replaceSpacesWithPlus(e.loanOfficerPhone)}`}
            rel="noopener noreferrer"
            target="_blank"
            className="ClientRow"
            key={index}
            onClick={() => {
              logActivity({
                apiKey: makeKey,
                userEmail: userEmail,
                userType: userType,
                action: "Select Client UCC Form",
                tab: "Account",
                userCompany: userCompany
              });
            }}
          >
            <div className="name">{e.clientName}</div>
          </a>
        );
      });
    }
  }

  return (
    <div className={`ModalPage ${uCCListModalVisible} one`}>
      <div className="Modal-background"></div>
      <div className="Modal-container">
        <form className="Modal">
          <div className="spaceBetween">
            <b>Submit a UCC</b>
            <div
              className="Modal-close"
              onClick={() => {
                setUCCListModalVisible("hidden");
              }}
            >
              {closeSvg}
            </div>
          </div>
          Start a new Under Contract Checklist by clicking a client below or "New Blank UCC +".
          {listOfClients}
          <div className="ClientRow-hr-holder">
            <div className="dotted-hr"></div>
          </div>
          <a
            className="ClientRow"
            href="https://be1app.netlify.app/transactions/ucc"
            rel="noopener noreferrer"
            target="_blank"
          >
            <div className="name">New Blank UCC +</div>
          </a>
        </form>
      </div>
    </div>
  );
};

export default UCCListModal;
